import {controller, attr} from '@github/catalyst'
import type {IFeedFilterValue} from './feed-filter-element'
import {FeedFilterElement} from './feed-filter-element'
import {pickBy, isEqual} from 'lodash-es'

interface IFeedFilterNextValue extends IFeedFilterValue {
  RepositoryActivity: boolean
  StarredRelationships: boolean
}

@controller
export class FeedFilterNextElement extends FeedFilterElement {
  @attr default: string

  private get defaultValues(): IFeedFilterNextValue {
    return JSON.parse(this.default)
  }

  private get filterChangesCount(): number {
    const diff = pickBy(this.filterValues, (v, k) => isEqual(this.defaultValues[k as keyof IFeedFilterNextValue], v))
    return Object.keys(diff).filter(k => k !== 'StarredRelationships').length
  }

  override connectedCallback() {
    this.updateFilterCounter()
  }

  public resetFilterToDefault() {
    const filter = this.defaultValues
    for (const input of this.inputs) {
      const name = input.getAttribute('name') as keyof IFeedFilterNextValue
      switch (input.type) {
        case 'checkbox':
          input.checked = this.defaultValues[name]
          break
        default:
          throw new Error(`Unexpected tag name: ${input.tagName}`)
      }
    }

    this.setFilterValue(filter)
  }

  public override async handleApply() {
    await super.handleApply()
    this.updateFilterCounter()
  }

  override async setFeedFilterSettings(previousTopic?: string | null): Promise<void> {
    await super.setFeedFilterSettings(previousTopic)
    this.updateFilterCounter()
  }

  private updateFilterCounter(): void {
    this.dispatchEvent(
      new CustomEvent('feed-filter-next:active-count', {
        bubbles: true,
        detail: {
          count: this.filterChangesCount,
        },
      }),
    )
  }
}
